import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { useViewportSize } from '@calendly/ui/hooks/viewport-size-context';
import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { CallieCapabilitySections } from './capability_sections';
import { CallieHeader } from './header';
import { CallieHowToUsePrompts } from './how_to_prompts';
const cardCss = "c12l7xmj";
const bodyCss = "bd1ekfd";
const sidebarCss = "s1ll15ii";
const stackedSidebarCss = "s1igl5j3";
export const Callie = () => {
  const {
    isSmallViewport
  } = useViewportSize();
  const [expandedSectionId, setExpandedSectionId] = useState(null);
  const callieTitle = I18n.t('publisher.home.scheduling_subsection.tabs.callie');
  const schedulingTitle = I18n.t('publisher.home.page_header.scheduling');
  usePageTitle(`${callieTitle} - ${schedulingTitle} - Calendly`);
  const handleToggleSection = useCallback(sectionId => {
    setExpandedSectionId(currentSectionId => currentSectionId === sectionId ? null : sectionId);
  }, []);
  return <div data-testid="callie-tab-content">
      <div className={cardCss} data-testid="callie-card">
        <CallieHeader />
        <div className={bodyCss}>
          <CallieCapabilitySections expandedSectionId={expandedSectionId} onToggleSection={handleToggleSection} />
          <div className={classNames(sidebarCss, isSmallViewport && stackedSidebarCss)}>
            <CallieHowToUsePrompts />
          </div>
        </div>
      </div>
    </div>;
};

require("./callie.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./callie.js");